import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'bosch-ui-table-header-cell',
  templateUrl: './bosch-ui-table-header-cell.component.html',
  styleUrls: ['./bosch-ui-table-header-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiTableHeaderCellComponent {}
